import React from "react";
import Table from "./components/table/Index";
import tableData from "./components/table/tableData.json";

import "./components/table/styles.css";

const columns = [
  { label: "ПІБ", accessor: "name", sortable: true },
  { label: "Телефон", accessor: "email", sortable: true },
  { label: "Кімната", accessor: "room", sortable: true },
  { label: "Місце", accessor: "place", sortable: true },
  { label: "Оплата", accessor: "payment", sortable: true },
  { label: "Поле", accessor: "field", sortable: true },
  { label: "Місто", accessor: "city", sortable: true },
  { label: "Служитель", accessor: "minister", sortable: true },
];

const TableList = ({ list }) => {
  const data = list.map((item) => ({
    id: item.id,
    name: item.name,
    email: item.email,
    room: item.bed?.apartment?.number ? item.bed?.apartment?.number : "---",
    place: item.bed?.number ? item.bed?.number : "---",
    payment: item.payment?.type === "CASH" ? "Готівка" : "Карта",
    field: item.address?.field?.name,
    city: item.address?.city,
    minister: item.minister,
  }));

  console.log("data", data);

  return (
    <div className="table_container">
      <Table data={data} columns={columns} />
      <br />
      <br />
    </div>
  );
};

export default TableList;
